if (!customElements.get('zenova-nutrition')) {
  customElements.define('zenova-nutrition', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const opener = this.querySelector('[data-zps-open]');
      const dialog = this.querySelector('dialog');
      if (!opener || !dialog) return;
      opener.addEventListener('click', () => {
        this.previousOverflow = document.documentElement.style.overflow;
        dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
      });
      this.querySelector('[data-zps-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => {
        document.documentElement.style.overflow = this.previousOverflow || '';
        opener.focus({ preventScroll: true });
      });
    }
    disconnectedCallback() {
      if (this.querySelector('dialog[open]')) {
        document.documentElement.style.overflow = this.previousOverflow || '';
      }
    }
  });
}
